import { createContext, useContext } from "react"

// Kept apart from the host so a link can open a sheet without importing the
// pages the host renders inside its sheets.
export const BillingSheetsContext = createContext(null)

export const useBillingSheets = () => useContext(BillingSheetsContext)

// A plain left click opens the sheet in place; a modified one keeps the
// browser's behavior, such as opening the full page in a new tab.
export const opensInPlace = (event) =>
  event.button === 0 &&
  !event.metaKey &&
  !event.ctrlKey &&
  !event.shiftKey &&
  !event.altKey
